import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { currentUserId as getCurrentUserId, currentUserIsInAdminRole as getCurrentUserIsInAdminRole } from "reduxSlices/sessionSlice"
import { REPORT_SFTP_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import ItemRow from "shared/ItemRow"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import Tooltip, { TOP_CENTER } from "components/shared/Tooltip"
import NewReportExportLink from "./ReportElements/NewReportExportLink"
import ReportMenu from "./ReportElements/ReportMenu"
import ExpandedRowContent from "./ExpandedRowContent"

const ReportRow = ({
  editPath, editScheduledReportExportPath, newReportExportPath, newScheduledReportExportPath, report, reportType,
}) => {
  const currentUserId = useSelector(getCurrentUserId)
  const currentUserIsInAdminRole = useSelector(getCurrentUserIsInAdminRole)
  const subscribedToSFTP = useSelector(subscribedToAddOnFeature(REPORT_SFTP_FEATURE_NAME))

  const {
    shared, creatorId, creatorFullName, scheduledReportExport,
  } = report

  const createdByCurrentUser = currentUserId === creatorId

  return (
    <ItemRow
      collapsable={subscribedToSFTP && currentUserIsInAdminRole}
      itemRowBody={(
        <ExpandedRowContent
          report={report}
          reportType={reportType}
          newScheduledReportExportPath={newScheduledReportExportPath}
          editScheduledReportExportPath={editScheduledReportExportPath}
        />
      )}
      itemRowHeaderContent={(
        <>
          <div className="grow">
            {report.name}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {
              shared && !createdByCurrentUser && (
                <div className="text-sm text-dark">shared by {creatorFullName}</div>
              )
            }
            {
              scheduledReportExport && scheduledReportExport.scheduledReportExportSchedule.active
              && (
                <Tooltip
                  className="overflow-y-auto"
                  maxHeight="max-h-60"
                  position={TOP_CENTER}
                  text="SFTP Uploads Active"
                >
                  <SvgSpriteIcon iconName="rotate" />
                </Tooltip>
              )
            }
            <NewReportExportLink location={newReportExportPath(report.id)} />
          </div>
        </>
      )}
      itemRowHeaderContentClassName="gap-8"
      itemRowHeaderControls={(
        <ReportMenu report={report} reportType={reportType} editPath={editPath} />
      )}
    />
  )
}

ReportRow.propTypes = {
  reportType: types.string.isRequired,
  editPath: types.func.isRequired,
  newReportExportPath: types.func.isRequired,
  newScheduledReportExportPath: types.func.isRequired,
  editScheduledReportExportPath: types.func.isRequired,
  report: types.objectOf(types.any).isRequired,
}

export default ReportRow
